import React, { Component } from 'react';
import PropTypes from 'prop-types';
import QuestionPickerSection from './MemberApplicationQuestionPicker/QuestionPickerSection';
import QuestionSchemaInputSection from './MemberApplicationQuestionPicker/QuestionSchemaInputSection';
import ReadOnlySection from './MemberApplicationQuestionPicker/ReadOnlySection';

export default class MemberApplicationQuestionPicker extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.object,
    questions: PropTypes.array.isRequired,
    sections: PropTypes.array.isRequired,
    questionSchemaInputProps: PropTypes.object,
  }

  static defaultProps = {
    value: {},
    questionSchemaInputProps: {},
  }

  constructor(props) {
    super(props);

    this.state = {
      questions: this.props.questions || [],
      pickedQuestions: this.props.value || {},
    };
  }

  // Global QuestionPicker event handlers

  questionPicked(question) {
    return this.state.pickedQuestions[question.field] !== undefined;
  }

  pickQuestion(question, required = false) {
    const pickedQuestions = this.state.pickedQuestions;
    pickedQuestions[question.field] = { required };
    return pickedQuestions;
  }

  unpickQuestion(question) {
    delete this.state.pickedQuestions[question.field];
    return this.state.pickedQuestions;
  }

  toggleQuestion(question) {
    return this.questionPicked(question) ? this.unpickQuestion(question) : this.pickQuestion(question);
  }

  handleToggleQuestion(question) {
    const pickedQuestions = this.toggleQuestion(question);
    this.setState({ pickedQuestions });
  }

  toggleRequired(question) {
    if (!this.questionPicked(question)) { return this.pickQuestion(question, true); }

    const pickedQuestions = this.state.pickedQuestions;
    pickedQuestions[question.field].required = !pickedQuestions[question.field].required;
    return pickedQuestions;
  }

  handleToggleRequired(question) {
    const pickedQuestions = this.toggleRequired(question);
    this.setState({ pickedQuestions });
  }

  // QuestionPickerSection rendering

  filterPickedQuestionsToQuestionSet(questions) {
    const questionFields = questions.map((q) => (q.field));
    const pickedQuestions = {};
    Object.entries(this.state.pickedQuestions).forEach(([k, v]) => {
      if (questionFields.includes(k)) { pickedQuestions[k] = v; }
    });
    return pickedQuestions;
  }

  renderQuestionPickerSection(section, key, questions) {
    const pickedQuestions = this.filterPickedQuestionsToQuestionSet(questions);
    return (
      <QuestionPickerSection
        section={section}
        questions={questions}
        onToggleSelect={this.handleToggleQuestion.bind(this)}
        onToggleRequire={this.handleToggleRequired.bind(this)}
        pickedQuestions={pickedQuestions}
        key={key}
      />
    );
  }

  // QuestionSchemaInputSection rendering

  renderQuestionSchemaInputSection(section, key) {
    return (
      <QuestionSchemaInputSection
        section={section}
        questionSchemaInputProps={this.props.questionSchemaInputProps}
        key={key}
      />
    );
  }

  // ReadOnlySection rendering

  renderReadOnlySection(section, key) {
    return (
      <ReadOnlySection section={section} key={key} />
    );
  }

  // MemberApplicationQuestionPicker rendering

  renderSection(section) {
    const key = `section-${section.slug}`;

    if (section.customQuestionsSection) {
      return this.renderQuestionSchemaInputSection(section, key);
    }

    const questions = this.props.questions.filter((q) => q.section === section.slug);

    if (questions.length === 0) {
      return this.renderReadOnlySection(section, key);
    }

    return this.renderQuestionPickerSection(section, key, questions);
  }

  render() {
    const sectionTables = this.props.sections.map(this.renderSection.bind(this));
    return (
      <div className="u-ml-4">
        {sectionTables}
        <input name={this.props.name} type="hidden" value={JSON.stringify(this.state.pickedQuestions)} />
      </div>
    );
  }
}
